import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { AvailableCurrencies } from 'utils/clickme';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { FILTER_STATUS_WAITING_DOC } from 'utils/constants/invoice';
import { Permissions } from 'utils/constants/permissions';
import { formatDate } from 'utils/date';

import { Link } from '@hh.ru/redux-spa-middleware';

import BlokoLink, { LinkKind } from 'bloko/blocks/link';

import InvoiceStatus from 'components/InvoiceStatus';
import KMNumber from 'components/KMNumber';

import Gift from 'components/Admin/Gift';
import Account from 'components/Admin/Invoices/InvoicesTable/Invoice/Account';
import Amounts from 'components/Admin/Invoices/InvoicesTable/Invoice/Amounts';
import Payer from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer';
import Requisites from 'components/Admin/Invoices/InvoicesTable/Invoice/Requisites';
import { User } from 'components/Admin/Invoices/InvoicesTable/Invoice/User';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

import 'components/Admin/Invoices/InvoicesTable/Invoice/Invoice.less';

const Invoice = ({
    id,
    amount,
    userId,
    status,
    createdAt,
    auto,
    promoBonus,
    payerId,
    payerType,
    accountId,
    account,
    showGiftButton,
    accountCurrency,
    ...invoice
}) => {
    const { permissions } = useSelector((state) => state.user);
    const invoiceDate = (
        <span className="invoices__invoice-date" data-qa="invoice-date">
            {formatDate(createdAt, VIEW_DATE_FORMAT)}
        </span>
    );
    return (
        <TableRow>
            <TableCell>
                {permissions.includes(Permissions.ViewAdminInvoiceDetailPage) ? (
                    <BlokoLink
                        Element={Link}
                        kind={LinkKind.Tertiary}
                        to={`/new/admin/invoices/${id}/`}
                        data-qa="invoice-link"
                    >
                        {invoiceDate}
                    </BlokoLink>
                ) : (
                    invoiceDate
                )}
            </TableCell>
            <TableCell>
                <Account account={account} accountId={accountId} />
            </TableCell>
            <TableCell>
                <Requisites payerType={payerType} promoBonus={promoBonus} userId={userId} {...invoice} />
                {status === FILTER_STATUS_WAITING_DOC && (
                    <span className="invoices__waiting-doc">
                        <Payer payerId={payerId} payerType={payerType} auto={auto} />
                    </span>
                )}
            </TableCell>
            <TableCell>
                <p>
                    <KMNumber userId={userId} payerType={payerType} {...invoice} withLabel />
                </p>
                <Amounts amount={amount} promoBonus={promoBonus} />
            </TableCell>
            <TableCell>
                <InvoiceStatus status={status} />
            </TableCell>
            <TableCell>
                {userId && (
                    <Fragment>
                        <User userId={userId} {...invoice} />
                        {showGiftButton && accountCurrency === AvailableCurrencies.RUR && (
                            <Gift accountId={accountId} userId={userId} />
                        )}
                    </Fragment>
                )}
            </TableCell>
        </TableRow>
    );
};

Invoice.propTypes = {
    id: PropTypes.number,
    amount: PropTypes.number,
    userId: PropTypes.number,
    title: PropTypes.string,
    status: PropTypes.string,
    createdAt: PropTypes.string,
    auto: PropTypes.bool,
    number: PropTypes.number,
    promoBonus: PropTypes.number,
    payerId: PropTypes.number,
    payerType: PropTypes.string,
    accountId: PropTypes.number,
    address: PropTypes.any,
    post: PropTypes.any,
    inn: PropTypes.any,
    account: PropTypes.object,
    showGiftButton: PropTypes.bool,
    accountCurrency: PropTypes.string,
};

export default Invoice;
